import script from "./HeaderTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTabBar.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTabBar.vue?vue&type=style&index=0&id=2a7bf2e0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7bf2e0"]])

export default __exports__